<template>
  <div
    class="flex flex-col items-center p-40 my-40 border rounded border-grey-300"
  >
    <h6 class="text-center">{{ displayCheck }}</h6>
    <p class="mt-20 text-center">{{ displayExplanation }}</p>
    <p class="mt-20 text-center">
      {{ displayCodeSent }}
    </p>
    <p class="mt-20 text-center">{{ $t('mfa.active') }}</p>
    <CodeInput
      class="mt-20"
      canCancel
      :codeError="codeError"
      @cancel="$emit('cancel')"
      @confirm="confirm"
    />
    <div v-if="displayCodeResend" class="flex items-center mt-20">
      <Icon iconClass="far fa-check-circle text-green-500" />
      <span class="ml-10">{{ $t('mfa.resend_code_sent') }}</span>
    </div>
    <div v-else class="mt-20">
      {{ $t('mfa.resend_prompt') }}
      <a class="text-blue-500 underline" @click="send">
        {{ $t('mfa.resend_code') }}
      </a>
    </div>
    <div class="flex flex-row mt-10 items-start">
      <Icon iconClass="fas fa-info-circle mr-10 text-grey-500" />
      <span class="text-sm text-grey-500">
        {{ helperText }}
      </span>
    </div>
  </div>
</template>
<script>
import CodeInput from '@components/common/forms/CodeInput'

export default {
  components: { CodeInput },
  props: {
    helperText: {
      type: String,
      required: true,
    },
    codeError: {
      type: Boolean,
      required: true,
    },
    autoSendCode: {
      type: Boolean,
      default: false,
    },
    displayCheck: {
      type: String,
      required: true,
    },
    displayExplanation: {
      type: String,
      required: true,
    },
    displayCodeSent: {
      type: String,
      required: true,
    },
    displayCodeResend: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showCodeSent: false,
    }
  },
  created() {
    this.sendCodeOnCreated()
  },
  methods: {
    confirm(totp) {
      this.$emit('verifyMfaCode', totp)
    },
    sendCodeOnCreated() {
      if (this.autoSendCode) {
        this.send()
      }
    },
    send() {
      this.$emit('requestMfaCode')
    },
  },
}
</script>
